import { render, staticRenderFns } from "./xy_chart.vue?vue&type=template&id=2d712c06&"
import script from "./xy_chart.vue?vue&type=script&lang=js&"
export * from "./xy_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports